module.exports = __webpack_public_path__ + "static/media/Simon-1.bb97d5ba.jpeg";